
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/faq",
      function () {
        return require("private-next-pages/de/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/de/faq"])
      });
    }
  